import React from 'react';
import SharedDetails from '../../Components/SharedDetails/SharedDetails';

const columns = [{ title: 'Vendor Name', field: 'VendorName' }];
const csvHeaders = [{ label: 'Vendor Name', key: 'VendorName' }];

const VendorDetails = () => (
  <SharedDetails
    columns={columns}
    csvFilename="vendor-details.csv"
    csvHeaders={csvHeaders}
    emptyMessage="No vendor records found."
    pagedEndpoint="/api/get/vendor/paged"
    errorMessage="Unable to load vendors. Please try again."
    loadingMessage="Loading vendors..."
    title="Vendor Details"
  />
);

export { VendorDetails };
export default VendorDetails;
